import { Component, OnInit, ViewEncapsulation, Renderer2, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { Router } from '@angular/router';
import { RouteNames } from '../../../shared/routing/app-routing.constants';
import { BrokerInfo } from '../../models/BrokerInfo';
import { SessionService } from '../../../core/services/session.service';
import { ModalComponent } from '../modal/modal.component';
import * as wb from '@ag/brokersearch/bundle';
@Component({
  selector: 'app-broker-tool',
  templateUrl: './broker-tool.component.html',
  styleUrls: ['./broker-tool.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BrokerToolComponent implements OnInit, AfterViewInit{

  @ViewChild('brokerModal') brokerModal: ModalComponent;
  brokerurl: SafeResourceUrl;
  param: string;
  @Input() hasBroker: boolean;
  @Input() fromWidget: boolean;
  @Input() culture: string;
  @Output() BrokerSelectedFromWidget: EventEmitter<boolean> = new EventEmitter<boolean>();
  listenerFn: () => void;
  brokerDetails: BrokerInfo;
  brokerLogoCustomChange: string;
  @ViewChild('brokerSearchTool') brokerTool: ElementRef<HTMLInputElement>;

  constructor(
              private renderer: Renderer2,
              private router: Router,
              private session: SessionService) {}  

  ngOnInit(): void {
      wb();
  }

    ngAfterViewInit(){ 
      this.renderer.setAttribute(this.brokerTool.nativeElement,"language", this.culture);
      this.renderer.setAttribute(this.brokerTool.nativeElement, "urlEnvironment", AgAppConfigService.get<string>("BrokerListUrl"));
      this.renderer.setAttribute(this.brokerTool.nativeElement, "urlGetBrokerDetail", AgAppConfigService.get<string>("BrokerDetailUrl"));
      setTimeout(() => {
        this.initializeBrokerSearchTool();
      },500);
      
    }

    initializeBrokerSearchTool(){
      const agBrokerSearch = document.querySelector("ag-brokersearch");
      agBrokerSearch?.addEventListener("OnBrokerSelected", (e:CustomEvent) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        this.brokerDetails = JSON.parse(e.detail.text());
        this.brokerLogoCustomChange = this.brokerDetails?.logoUrl + '.png';

        this.session.setBrokerDetails(this.brokerDetails);
        sessionStorage.setItem('SelectedBrokerPId', this.brokerDetails.publicId);
        const userParams = this.session.getUserParams();
        userParams.partnercode = sessionStorage.SelectedBrokerPId as string|number;
        this.session.setModifiedUserParam(userParams);
        this.session.setHeaderContext(this.brokerDetails.logoUrl ? this.brokerLogoCustomChange : null, this.brokerDetails.websiteUrl ? this.brokerDetails.websiteUrl : null, true);

        if (!this.fromWidget){
          void this.router.navigate(['/' + RouteNames.simulation + '/' + RouteNames.simulationBrokerInfo]);
        }else{
           this.BrokerSelectedFromWidget.emit(true);
        }
        // setTimeout(() => {
        //   delete window?.google?.maps;
        // },1000);
    }); 
    }
 

  // getBrokerIframeData(e: MessageEvent) {
  //   if (e.origin === location.origin) {
  //     if (typeof (e.data) === 'object' && e.data.BrokerId) {
  //       sessionStorage.setItem('SelectedBrokerId', e.data.BrokerId);
  //       sessionStorage.setItem('SelectedBrokerPId', e.data.BrokerPId); // saving the selected the broker id in session
  //       if (!this.fromWidget){
  //         this.router.navigate(['/' + RouteNames.simulation + '/' + RouteNames.simulationBrokerInfo]);
  //         this.listenerFn();
  //       }else{
  //         this.BrokerSelectedFromWidget.emit(true);
  //         this.listenerFn();
  //       }
  //     }else if (typeof (e.data) === 'object' && e.data.height){
  //       document.getElementById('brokersearchid').style.height = e.data.height; // adjusting the pop-up height as per the iframe
  //     }
  //   }
  // }

  // loadFrame(framedata: HTMLIFrameElement)
  // {

  //   // passing the selected language and whether the user knows the broker or not
  //   const frameObject = {
  //     currentlanguage: this.agConfiguration.configuration.currentLanguage,
  //     hasBroker: this.hasBroker
  //   };
  //   framedata.contentWindow.postMessage(frameObject , window.location.origin);

  //   // Fetching the height of the iframe and the selected broker from the map
  //   this.listenerFn = this.renderer.listen('window', 'message', (e) => this.getBrokerIframeData(e));
  // }

  // ngOnDestroy() {
  //   this.subscription.unsubscribe();
  // }

}
